import './gandanHistory.css';

const GandanHistory = () => {
    return (
        <main>
            <h1>Гандан хийдийн түүх</h1>
            {/* <h1>Эрдэнэмандал хийдийн түүх</h1> */}
        </main>
    )
}
export default GandanHistory;